import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShell } from "@client/components/app-shell";
import { AiDocumentCreator } from "@client/components/ai-document-wizard";

export const Route = createFileRoute("/documents/new-ai")({
  beforeLoad: async () => {
    const res = await fetch("/api/me", { credentials: "include" });
    if (!res.ok) throw redirect({ to: "/login" });
  },
  component: NewAiDocumentPage,
});

function NewAiDocumentPage() {
  return (
    <AppShell pageEyebrow="Acervo" pageTitle="Criar documento com IA">
      <AiDocumentCreator />
    </AppShell>
  );
}
